import { AnnualReportExcelRow } from './annual-report-excel-row.interface';

export class AnnualReportExcelSheetTable {
    headers: string[];
    rows: AnnualReportExcelRow[];
}
